import { TrackingService } from '@/shared/services/tracking.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'base-tracking',
  standalone: false,
  templateUrl: './base-tracking.component.html',
  styleUrl: './base-tracking.component.css',
})
export class BaseTrackingComponent {
  public trackingService!: TrackingService;
  public router!: Router;
  public intervalId: any;
  private windowScrollSubject = new Subject<void>();
  private containerScrollSubject = new Subject<Event>();
  private mouseMoveSubject = new Subject<MouseEvent>();

  constructor() {
    const platformId = inject(PLATFORM_ID);
    this.router = inject(Router);
    this.trackingService = inject(TrackingService);

    if (isPlatformBrowser(platformId)) {
      this.intervalId = setInterval(() => {
        this.trackingService.trackActions();
      }, 5000); // 5 seconds

      // Debounce the window scroll tracking
      this.windowScrollSubject.pipe(debounceTime(300)).subscribe(() => {
        this.trackingService.addActionTrackingData('scroll', this.router.url);
      });

      // Debounce the window scroll tracking
      this.mouseMoveSubject.pipe(debounceTime(300)).subscribe(() => {
        this.trackingService.addActionTrackingData(
          'mousemove',
          this.router.url,
        );
      });

      // Debounce the container scroll tracking
      this.containerScrollSubject.pipe(debounceTime(300)).subscribe(() => {
        this.trackingService.addActionTrackingData('scroll', this.router.url);
      });
    }
  }

  // Track clicks globally
  @HostListener('document:click', ['$event'])
  onClick(_event: MouseEvent) {
    this.trackingService.addActionTrackingData('click', this.router.url);
  }

  // Track scrolling when full window is scrolled
  @HostListener('window:scroll', [])
  onScroll() {
    this.windowScrollSubject.next(); // Emit an event for debouncing
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(_event: Event) {
    this.trackingService.trackActions();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mouseMoveSubject.next(event); // Emit event for debouncing
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(_event: KeyboardEvent) {
    this.trackingService.addActionTrackingData('keydown', this.router.url);
  }

  // Track scrolling when a specific document is scrolled
  onContainerScroll(event: Event) {
    this.containerScrollSubject.next(event); // Emit event for debouncing
  }
}
